import type { ContactPreferencesSiteSettings } from '../../contactPreferences.types.ts';

const CONTACT_PREFERENCES: ContactPreferencesSiteSettings = {
  availableChannels: ['email', 'sms', 'phone', 'post', 'trustedPartners'],
  channelIcons: {
    email: 'Email',
    sms: 'ChatTyping',
    phone: 'Mobile',
    post: 'MailOpen',
  },
  channelTrackingNames: {
    email: 'Email',
    sms: 'SMS',
    phone: 'Phone',
    post: 'Post',
  },
};

export { CONTACT_PREFERENCES };
